module.exports = __webpack_public_path__ + "static/logo-610c4d2260d34842ea84443ccc992ce8.png";